import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import { Field, FormikProvider, useFormik } from 'formik'
import CustomInput from '../../../components/common/CustomInput'
import * as Yup from 'yup'

const validationSchema = Yup.object({
  size: Yup.string().trim().required('Size is required'),
})

function Edit() {
  const navigate = useNavigate()
  const { id } = useParams()
  const [loading, setLoading] = useState(true)

  const formik = useFormik({
    onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
    validationSchema,
    initialValues: {
      name: '',
    },
  })

  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get(`size/detail/${id}`)
      formik.setValues({
        size: response.data.result.size,
      })
      setLoading(false)
    } catch (error) {
      console.log('error in fetching edit data: ', error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [id])

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const response = await axiosAuthInstance.put(`size/update/${id}`, {
        size: values.size,
      })
      if (response) {
        navigate('/size')
      }
    } catch (error) {
      console.log(error)
    }
  }

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <FormikProvider value={formik}>
      <form
        className='flex flex-col p-4 gap-4'
        onSubmit={(e) => {
          e.preventDefault()
          formik.handleSubmit()
        }}
      >
        <Field
          name='size'
          label='Size'
          placeholder='Enter Size'
          required
          component={CustomInput}
        />

        <button
          type='submit'
          disabled={formik.isSubmitting}
          className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'
        >
          Update
        </button>
      </form>
    </FormikProvider>
  )
}

export default Edit
